import { useEffect } from 'react'

import { useSelection } from '../../../../hooks'
import { useAsyncTable } from '../../../Table'
import { isDocFlowActiveWidgetResult } from '../../DocFlow.utils.widgets'
import { getDocFlowMapppingResultTableApiUrls } from '../../DocFlowMapping'
import { useDocFlowContext } from '../useDocFlowContext'
import { useDocFlowMappingContext } from '../useDocFlowMappingContext'
import { useDocFlowMappingResultTableActions } from '../useDocFlowMappingResultTableActions'

export function useDocFlowMappingResultTable() {
  const { documentId, mappingPhaseFileActive, phaseDisabled } =
    useDocFlowContext()

  const { activeFile, activeWidget } = useDocFlowMappingContext()

  const tableData = useAsyncTable({
    ...getDocFlowMapppingResultTableApiUrls(documentId, activeFile.itemId),
    withoutSubMenu: true,
  })

  const {
    filterValues,
    handleLoadInit,
    handleReload,
    items: tableItems,
    ordering,
    pagination,
  } = tableData

  const selectionData = useSelection({ data: tableItems, pagination })

  useEffect(() => {
    handleLoadInit()
  }, [])

  const { actionLoading, setItemAction, setMassAction } =
    useDocFlowMappingResultTableActions({
      filterValues,
      ordering,
      pagination,
      selectionData,
      tableItems,
      onReloadTable: handleReload,
    })

  useEffect(() => {
    if (
      mappingPhaseFileActive &&
      isDocFlowActiveWidgetResult(activeWidget) &&
      tableItems
    ) {
      handleLoadInit()
    }
  }, [mappingPhaseFileActive])

  return {
    actionLoading,
    phaseDisabled,
    selectionData,
    setItemAction,
    setMassAction,
    tableData,
  }
}
